/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Contract_Addons_TitleInputs */



/**
* | output |
* | --- |
* | "Add-ons are set by your contract" |
*
* @param {Sub_Contract_Addons_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_contract_addons_title = /** @type {((inputs?: Sub_Contract_Addons_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Contract_Addons_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Add-ons sind vertraglich festgelegt")
	return /** @type {LocalizedString} */ ("Add-ons are set by your contract")
});